module.exports = __webpack_public_path__ + "img/Logo.03cb2db6.png";